import Vue from 'vue'
import PanelRow from '@/helpers/components/panels/PanelRow'
import Panel from '@/helpers/components/panels/Panel'
import Loading from '@/helpers/components/interact/Loading'
import close from '@/helpers/components/interact/close'

Vue.component('PanelRow', PanelRow);
Vue.component('Panel', Panel);
Vue.component('Loading', Loading);
Vue.directive('close', close);

//global mixin
Vue.mixin({
  computed: {
    $reemit () {
      var self = this;
      var emit = this.$emit;
      return new Proxy({}, {
        get: function(obj, event) {
          return function () {
            var args = Array.prototype.slice.call(arguments);
            args.unshift(event);
            return emit.apply(self, args);
          };
        }
      });
    },
  },
  methods: {
    promise (key, condition = a=>a) {
      return new Promise(resolve => {
        if (condition(this[key])) {
          return resolve(this[key]);
        }
        var unwatch = this.$watch(key, () => {
          if (condition(this[key])) {
            unwatch();
            return resolve(this[key]);
          }
        })
      })
    },
  },
});


// WEBPACK FOOTER //
// ./src/providers/common_components.js